import script from "./platformInstitutions.vue?vue&type=script&setup=true&lang=js"
export * from "./platformInstitutions.vue?vue&type=script&setup=true&lang=js"

import "./platformInstitutions.vue?vue&type=style&index=0&id=45de905d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45de905d"]])

export default __exports__